import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';

export default class PieChartComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { colors, data, options } = this.props;

    const pieOptions = {
      colors,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: { enabled: false },
      showInLegend: false,
      ...options,
    };

    Highcharts.chart(this.containerRef.current, {
      chart: {
        type: 'pie',
        backgroundColor: null,
        margin: 0,
        height: this.containerRef.current.offsetWidth,
      },
      title: { text: '' },
      tooltip: { pointFormat: '' },
      credits: { enabled: false },
      plotOptions: {
        pie: pieOptions,
        series: {
          states: {
            hover: { enabled: true },
          },
        },
      },
      series: [
        {
          data,
        },
      ],
    });
  }

  render() {
    return <div ref={this.containerRef} />;
  }
}

PieChartComponent.propTypes = {
  data: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
};
